<template>
  <div>
    <div v-show="visible" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header" class="text-center">
              <i class="fas fa-info-circle"></i>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body" class="text-center">
              <p>
                The <i>save</i> button has not yet been clicked at least once.
              </p>
              <p>Are you sure you want to navigate away from the Add page?</p>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <div class="text-center">
                <button
                  class="btn btn-large btn-default"
                  style="width: 100px"
                  v-on:click="leavePage"
                >
                  Yes
                </button>
                <button
                  class="btn btn-large btn-default"
                  style="width: 100px"
                  v-on:click="stayOnPage"
                >
                  No
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" style="height: 800px">
      <div class="row">
        <h2 class="table-name" style="margin-bottom: 0">
          Adding to {{ readableName(table) }} Table
        </h2>
        <span
          v-if="table !== 'candidate_creation_workflow' && canUpdate"
          class="edit-add"
          ><router-link :to="`/tables/${table}`"
            >Switch to edit page</router-link
          ><i> (Ensure data is saved before navigating)</i></span
        >
        <hr />
      </div>
      <p>
        <b>Please note:</b> When pasting ID's, please wait for the name to
        render before continuing to edit other other fields.<span
          v-if="table === 'greenhouse_page_creation'"
        >
          If duplicate candidate IDs are submitted at the same time, the entries
          will not save.</span
        >
      </p>
      <p>
        <b>Instructions:</b> Enter new database records in the blank table
        below. When you are ready to insert the data into the database, click
        "Save". This will only add data for the rows you have filled out.
      </p>
      <p style="color: #bc243c">
        <b
          ><i>{{ pageDisclaimer }}</i></b
        >
      </p>
      <p style="color: #bc243c">
        <b
          ><i>{{ pageError }}</i></b
        >
      </p>
      <button
        class="btn btn-primary submit-btn"
        :style="visibility"
        v-if="canAdd"
        @click="submitData"
      >
        <i class="fa fa-sync" style="font-size: 16px"></i> Save
      </button>
      <button
        class="btn btn-primary submit-btn"
        style="width: 175px"
        :style="visibility"
        v-if="!showSearch && canAdd"
        @click="resetAddColumnOrder"
      >
        <i class="fa fa-undo" style="font-size: 16px"></i> Reset Column Order
      </button>
      <div v-if="loading" class="fa-3x text-center">
        <i class="fas fa-spinner fa-spin"></i>
      </div>

      <div class="row">
        <div
          v-if="this.$route.params.table === 'candidate_creation_workflow'"
          style="display: inline"
        >
          <div class="col-xs-5">
            <div class="col-xs-1">
              <label
                for="candidate_creation_workflow"
                style="margin-bottom: 15px"
                >Workflow:
              </label>
            </div>
            <div
              class="col-xs-4"
              style="margin-left: 12px; margin-bottom: 20px"
            >
              <select
                v-on:change="setWorkflow"
                v-model="workflow"
                class="form-control sortBy workflow"
                id="candidate_creation_workflow"
              >
                <option :value="' '">Before filing deadline</option>
                <option :value="'after_filing_deadline'">After filing deadline</option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-if="workflowOptions.length > 0"
          style="display: inline"
        >
          <div class="col-xs-5">
            <div class="col-xs-1">
              <label :for="`${table}_workflow`" style="margin-bottom: 15px"
                >Workflow:
              </label>
            </div>
            <div
              class="col-xs-4"
              style="margin-left: 12px; margin-bottom: 20px"
            >
              <select
                v-on:change="setWorkflow"
                v-model="workflow"
                class="form-control sortBy workflow"
                :id="`${table}_workflow`"
              >
               <option :value="''">All</option>
              <option
                v-for="wf in workflowOptions"
                :key="wf.workflow_name"
                :value="wf.workflow_name"
              >{{ wf.workflow_name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div
               v-if="this.$route.params.table === 'race_creation_workflow'"
              style="display: inline"
        >
        <div class="col-xs-5">
            <div class="col-xs-1">
              <label for="race_creation_workflow" style="margin-bottom: 15px"
                >Workflow:
              </label>
            </div>
             <div
              class="col-xs-4"
              style="margin-left: 12px; margin-bottom: 20px"
            >
              <select
                v-on:change="setWorkflow"
                v-model="workflow"
                class="form-control sortBy workflow"
                id="race_creation_workflow"
              >
                <option :value="''">All</option>
                <option :value="'GeneralOnly'">General only</option>
                <option :value="'PrimaryOnly'">Primary only</option>
              </select>
            </div>
          </div>
        </div>

      </div>
     <HandsOnTable
        :hotdata="hotdata"
        :table="table"
        :workflow="workflow"
        :columns="columnMetaData"
        ref="hot"
        :maxRows="500"
        :columnSorting="columnSorting"
        :dataSchema="dataschema"
        :comments= true
      ></HandsOnTable>
    </div>
  </div>
</template>

<script>
import HandsOnTable from "../components/HandsOnTable.vue";
import getColumnMetaData from "../mixins/columnMetaData.js";
import getPageDisclaimer from "../mixins/pageDisclaimers.js";
import getTablePermissions from "../mixins/getTablePermissions.js";
import { insertMixin } from "../mixins/crud.js";
import readableName from "../mixins/readableName";
import hideColumnsMixin from "../mixins/hideColumns.js";
import 'handsontable/dist/handsontable.full.css'

export default {
  name: "AddRecords",

  components: {
    HandsOnTable,
  },

  mixins: [
    getColumnMetaData,
    getPageDisclaimer,
    getTablePermissions,
    readableName,
    insertMixin,
    hideColumnsMixin,
  ],

  beforeRouteLeave(to, from, next) {
    if (this.to || this.submitAddsClicked) {
      next();
    } else {
      this.to = to;
      this.visible = true;
    }
  },

  methods: {
    
    resetAddColumnOrder() {
      localStorage.removeItem(`${this.table}-add`);
      this.$router.go();
    },


    leavePage() {
      this.showDialog = false;
      this.$router.push(this.to);
    },


    stayOnPage() {
      this.visible = false;
      this.to = null;
    },


    hideRaceCreationColumns() {
      let columnsToHide = [];
      if (this.workflow === 'GeneralOnly') {
        columnsToHide = this.hideRaceCreationColumnsSets.GeneralOnly;
      } else if (this.workflow === 'PrimaryOnly') {
        columnsToHide = this.hideRaceCreationColumnsSets.PrimaryOnly;
      }
      
      const hiddenColsIndexes = columnsToHide.map(col => this.hot.propToCol(col)).filter(index => !isNaN(index));
      
      this.hot.updateSettings({
        hiddenColumns: { columns: hiddenColsIndexes },
      });
    },


    hideCandidateCreationColumns() {
      const columnsToHide = this.workflow === 'after_filing_deadline'
        ? ['Official Candidacy Source', 'Description']
        : [];

      this.hot.updateSettings({
        hiddenColumns: { columns: this.hiddenColumnIndexesForNames(columnsToHide) },
      });
    },


    hideColumnsForWorkflow() {
      const selectedWorkflow = this.workflowOptions.find(wf => wf.workflow_name === this.workflow);
      const hiddenColsIndexes = selectedWorkflow
        ? this.hiddenColumnIndexesForWorkflow(selectedWorkflow.columns)
        : this.hiddenColumns;

      this.hot.updateSettings({
        hiddenColumns: { columns: hiddenColsIndexes },
      });
    },


    setWorkflow() {
      if (this.table === 'race_creation_workflow') {
        this.hideRaceCreationColumns();
        return;
      }

      if (this.table === 'candidate_creation_workflow') {
        this.hideCandidateCreationColumns();
        return;
      }

      if (this.workflowOptions.length > 0) {
        this.hideColumnsForWorkflow();
        return;
      }
    },


    hideColumns() {
      if (this.table === 'candidate_endorsements_staging') {
        // Because this restriction is roles-based, it does not fit into the DB-driven, user-selected workflows design
        const roles = localStorage.getItem('roles');
        if (roles.includes('local_candidate_endorsements_volunteer')) {
          this.hiddenColumns = this.hiddenColumnIndexesForWorkflow(
            ['ID', 'Candidate', 'URL', 'Endorser Type', 'Endorser Name', 'Endorser Title']
          );
        }
      }

      if (this.hiddenColumns.length > 0) {
        this.hot.updateSettings({
          hiddenColumns: {
            columns: this.hiddenColumns
          }
        });
      }
    },


    async submitData() {
      this.pageError = null;
      if (this.table.includes("workflow")) {
         await this.submitWorkflows();
      } else if (this.table.includes("greenhouse")) {
        await this.submitWorkflows();
      } else {
        await this.submitAdds();
      }
    },


    async submitAdds() {
      if (!this.initializeSubmission()) return;
      
      try {
        const sourceData = this.hot.getSourceData();
        const errors = await this.processAddRows(sourceData);
        
        if (errors.length > 0) {
          this.updateErrorComments(errors);
          this.hot.render();
        }
      } finally {
        this.finalizeSubmission();
      }
    },


    async submitWorkflows() {
      if (!this.initializeSubmission()) {
            return;
      }
      try {
        if (!this.validateGreenhouseData()) {
          return;
        } 
        const sourceData = this.hot.getSourceData();
        const errors = await this.processWorkflowRows(sourceData);
        
        if (errors.length > 0) {
          this.updateErrorComments(errors);
          this.hot.render();
        }
      } finally {
        this.finalizeSubmission();
      }
    },


    initializeSubmission() {
      if (this.workingOnSubmittedData) {
        return false;
      }
      
      this.submitAddsClicked = true;
      this.workingOnSubmittedData = true;
      this.loading = true;
      return true;
    },


    validateGreenhouseData() {
      if (!this.table.includes("greenhouse")) return true;
      
      const duplicateCandidates = this.checkForDupes();
      if (duplicateCandidates.length > 0) {
        this.finalizeSubmission();
        this.pageError = `No entries were saved. The following candidate IDs are duplicated on this page: ${duplicateCandidates}. Please remove the duplicates and resubmit the page.`;
        return false;
      }
      return true;
    },


    async processAddRows(sourceData) {
      const errors = [];
      
      for (let i = 1; i < sourceData.length; i++) { // Skip first row (index 0)
        const item = sourceData[i];
        
        if (this.shouldProcessAddRow(item)) {
          const error = await this.processAddRow(item, i);
          if (error) {
            errors.push(error);
          }
        }
      }
      
      return errors;
    },


    async processWorkflowRows(sourceData) {
      const errors = [];
      console.log(`Processing workflow rows. Total rows: ${sourceData.length}`);
      for (let i = 1; i < sourceData.length; i++) { // Skip first row (index 0)
        const item = sourceData[i];
        //console.log(`Evaluating row ${i} for processing:`, item);
        if (this.shouldProcessWorkflowRow(item)) {
          const error = await this.processWorkflowRow(item, i);
        
          if (error) {
            errors.push(error);
          }
        }
      }
      
      return errors;
    },


    shouldProcessAddRow(item) {
      return isNaN(item.id) || !item.id; // Only process rows without IDs (new records)
    },


    shouldProcessWorkflowRow(item) {
      return (isNaN(item.candidate_id) || !item.candidate_id) && 
            (isNaN(item.officeholder_id) || !item.officeholder_id) && 
            (isNaN(item.race_id) || !item.race_id) &&
            !item.page_results;
    },

    
    async processAddRow(item, rowIndex) {
      this.clearAddRowErrors(rowIndex);
      
      const dataObject = this.buildDataObject(item, rowIndex);
      
      if (Object.keys(dataObject).length === 0) {
        return null;
      }
      
      const payload = {
        data: [dataObject],
        table: this.table,
      };
      //console.log(`Submitting add row for row ${rowIndex} with payload:`, payload);
      // Validate on the front end
      const validationError = await this.validatePayload(payload, rowIndex);
      if (validationError) {
        return validationError;
      }
      
      const response = await this.insertRecord(payload);
      console.log("Add record response:", response);
      if (response.success === false) {
        return this.createErrorObject(rowIndex, response);
      } else {
        this.handleAddSuccess(response, rowIndex);
        return null;
      }
    },


    async processWorkflowRow(item, rowIndex) {

      if (this.table === "race_creation_workflow" && Object.keys(item).length > 0) { 
            await this.submitRaceStageWorkflow(item, rowIndex);
          return;
        }
      this.clearWorkflowRowErrors(rowIndex);
      
      const dataObject = this.buildDataObject(item, rowIndex);
      
      if (Object.keys(dataObject).length === 0) {
        return null;
      }
      
      //console.log(`Submitting workflow row for row ${rowIndex} with data:`, dataObject);
      const response = await this.submitWorkflowData(dataObject);
      
      if (response.success === false) {
        return this.createErrorObject(rowIndex, response);
      } else {
        this.handleWorkflowSuccess(response, rowIndex);
        return null;
      }
    },

 
    async submitRaceStageWorkflow(item, rowIndex) {
      console.log('Submitting') 
      // Create array to hold all the items we need to submit
    
      let itemsToSubmit;
      
      // Try to create the stage items and catch any validation errors
      try {
        itemsToSubmit = this.createRaceStageItems(item);
      } catch (error) {
        // Handle createRaceStageItems errors
        const createError = {
          row: rowIndex,
          error: error.message,
          stageType: 'Creation',
          stageParty: null
        };
        this.handleRaceStageSuccess([], [createError], rowIndex);
        return createError;
      }
      if (itemsToSubmit.length === 0) {
          return null;
      }
      
      const errors = [];
      const successfulSubmissions = [];
      
      // Submit each item - stop on first error
      for (const stageItem of itemsToSubmit) {
        try {
          //console.log(`Submitting stage item for row ${rowIndex}:`, stageItem);
          const response = await this.submitWorkflowData(stageItem);
          //console.log(response);
          if (response.success === false) {
            errors.push({
              ...this.createErrorObject(rowIndex, response),
              stageType: stageItem.stage_type,
              stageParty: stageItem.stage_party || null
            });
            // Stop processing on first error
            break;
          } else {
            successfulSubmissions.push({
              raceId: response.data.races_id,
              stageId: response.data.stages_id
            });
          }
        } catch (error) {
          errors.push({
            row: rowIndex,
            error: `Failed to submit ${stageItem.stage_type}: ${error.message}`,
            stageType: stageItem.stage_type,
            stageParty: stageItem.stage_party || null
          });
          // Stop processing on first error
          break;
        }
      }
      
      // Always call success handler with both arrays
      this.handleRaceStageSuccess(successfulSubmissions, errors, rowIndex);
      
      // Return first error if any exist, otherwise null
      return errors.length > 0 ? errors[0] : null;
    },


    createRaceStageItems(item) {
      const items = [];
      const hasGeneralDate = item.general_date && item.general_date !== ' ' && item.general_date != null && item.general_date.id;
      const hasPrimaryDate = item.primary_date && item.primary_date !== ' ' && item.primary_date != null && item.primary_date.id;
      
      //console.log(item)
      //console.log(`hasGeneralDate: ${hasGeneralDate}, hasPrimaryDate: ${hasPrimaryDate}`);
      if (!item.year || !item.office || !item.race_type || !item.number_of_seats || (!hasGeneralDate && !hasPrimaryDate)) {
          console.log(`Validation failed for item:`, item);
      throw new Error('Year, office, race type, number of seats, and at least one date are required.');
      }
      //console.log(`this is the item :`, item);
      // Base fields that are common to all stage types
      const baseFields = {
        race_year: parseInt(item.year),
        race_type: item.race_type,
        office: parseInt(item.office.id),
        number_of_seats: parseInt(item.number_of_seats),
        race_url: item.race_url,
        office_position: item.office_position,
        date_new_term_ends: item.date_new_term_ends,
        swearing_in_date: item.swearing_in_date,
        description: item.description
      };
      
      // Create General election stage if general_date exists
      if (item.general_date !=' ' && item.general_date != null && item.general_date.id) {
        items.push({
          ...baseFields,
          election_date: parseInt(item.general_date.id),
          stage_type: 'General',
          stage_party: null,// General election is not party-specific
          is_ranked_choice: item.is_ranked_choice_general || false
        });
      }
      
      // Create Primary election stage if primary_date exists
      if (item.primary_date !=' ' && item.primary_date != null && item.primary_date.id) {
      
        if (item.partisan_primary === true || item.partisan_primary === 'true' || item.partisan_primary === 1) {
          // Create two items for partisan primaries - one for each party
          items.push({
            ...baseFields,
            election_date: parseInt(item.primary_date.id),
            stage_type: 'Primary',
            stage_party: 1,
            is_ranked_choice: item.is_ranked_choice_rep_primary || false,
            stage_url: item.stage_url_R
          });
          
          items.push({
            ...baseFields,
            election_date: parseInt(item.primary_date.id),
            stage_type: 'Primary',
            stage_party: 2,
            is_ranked_choice: item.is_ranked_choice_dem_primary || false,
            stage_url: item.stage_url_D
          });
        } else {
          // Create single primary item for non-partisan
          items.push({
            ...baseFields,
            election_date: parseInt(item.primary_date.id),
            stage_type: 'Primary',
            stage_party: null,
            is_ranked_choice: item.is_ranked_choice_non_partisan_primary || false,
            stage_url: item.stage_url_NP
          });
        }
      }
      
      return items;
    },


    handleRaceStageSuccess(successfulSubmissions, errors, rowIndex) {
      // Build detailed status message showing all successes and errors
      let race_id = '';
      let stage_id = '';
      let statusMessage = '';
      
      if (successfulSubmissions.length > 0) {
        race_id = successfulSubmissions[0].raceId;  
        
        successfulSubmissions.forEach((submission, index) => {
          const { stageType, stageParty, raceId, stageId, response } = submission;
          stage_id += `${stageId} `;
          });
      }
      
      if (errors.length > 0) {
        statusMessage += `\nERRORS:\n`;
        errors.forEach((error, index) => {
          statusMessage += `${index + 1}. ${error.stageType}`;
          if (error.stageParty) statusMessage += ` (Party ${error.stageParty})`;
          statusMessage += `: ${error.error}\n`;
        });
      }

      // Only mark as successful (green) if there are NO errors
      if (errors.length === 0) {  
        // Total success - mark green
        //console.log(`column is :`, this.hot.propToCol('race_id'));
        this.hot.setDataAtCell(rowIndex, this.hot.propToCol('race_id'), race_id);
        this.hot.setDataAtCell(rowIndex, this.hot.propToCol('stage_ids'), stage_id);
        
        this.setCellMeta(rowIndex, "race_id", "className", "success");
        this.setCellMeta(rowIndex, "stage_ids", "className", "success");
      } else {
        
        this.updateErrorComments(errors);
      
        this.hot.setCellMeta(rowIndex, 0, "className", "validation-error");
      }
      
      this.hot.render();
    },


    clearAddRowErrors(rowIndex) {
      const errorColumn = this.hot.propToCol("id");
      this.$refs.hot.clearErrorValue(rowIndex, errorColumn);
    },


    clearWorkflowRowErrors(rowIndex) {
      try {
        this.$refs.hot.clearErrorValue(rowIndex, 0);
      } catch (error) {
        console.log(error);
      }
    },


    buildDataObject(item, rowIndex) {
      const dataObject = {};
      
      for (const col in item) {
        if (!item.hasOwnProperty(col)) continue;
        
        const errorColumn = this.getErrorColumn(col);
        this.$refs.hot.clearErrorValue(rowIndex, errorColumn);
        
        const dataType = this.getDataType(rowIndex, errorColumn);
        if (item[col] != null) {
          dataObject[col] = this.formatInsertPayloadItem(item[col], dataType);
        }
      }

      // Add default values for any boolean columns the user left untouched
      if (Object.keys(dataObject).length > 0) {
        this.columnMetaData.forEach(meta => {
          if (meta.dataType === 'boolean' && meta.default_value != null && dataObject[meta.data] == null) {
            try {
              dataObject[meta.data] = JSON.parse(meta.default_value);
            } catch (e) {
              // Default is not a simple true/false, let the database handle it (for now)
            }
          }
        });
      }

      return dataObject;
    },


    getErrorColumn(colName) {
      let errorColumn = this.hot.propToCol(colName);
      
      if (errorColumn === colName) {
        errorColumn = this.hot.propToCol(colName + '.id');
      }
      
      if (isNaN(errorColumn)) {
        const rowMeta = this.hot.getCellMetaAtRow(0);
        if (rowMeta && Array.isArray(rowMeta)) {
          const colMeta = rowMeta.filter(obj => {
            return obj && obj.__proto__ && obj.__proto__.colToUpdate === colName;
          });
          if (colMeta.length > 0 && colMeta[0] && typeof colMeta[0].col !== 'undefined') {
            errorColumn = colMeta[0].col;
          } else {
            errorColumn = 0;
          }
        } else {
          errorColumn = 0;
        }
      }
      
      return errorColumn;
    },


    getDataType(rowIndex, errorColumn) {
      const cellMeta = this.hot.getCellMeta(rowIndex, errorColumn);
      let dataType = cellMeta.__proto__.dataType;
      
      if (!dataType && cellMeta.__proto__.allow_multiple_values) {
        dataType = "ARRAY";
      }
      
      return dataType;
    },


    async validatePayload(payload, rowIndex) {
      try {
        const validate = await this.validateInsert(payload, rowIndex);
        
        if (validate && validate.errors) {
          return {
            row: rowIndex,
            error: validate.errors,
          };
        }
        
        return null;
      } catch (error) {
        console.log(error);
        return null; // Continue processing other rows
      }
    },


    async submitWorkflowData(dataObject) {
      const payload = {
        data: [dataObject],
        table: this.table,
      };
      
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "resource": `${process.env.VUE_APP_API4_DOMAIN}/custom_workflow`
      };
      //console.log("Submitting workflow data with payload:", payload);
      const response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      
      return await response.json();
    },


    createErrorObject(rowIndex, response) {
      let errorMessage = JSON.parse(response.message).message;
      
      if (errorMessage === 'error: duplicate key value violates unique constraint "people_unique"') {
        errorMessage = "error: The url already exists";
      }
      
      return {
        row: rowIndex,
        error: errorMessage,
      };
    },


    handleAddSuccess(response, rowIndex) {
      const newId = Number(response.data.id);
      
      // Set the new ID
      this.setCell(rowIndex, "id", newId);
      this.setCellMeta(rowIndex, "id", "className", "success");
      
      // Make all columns in this row read-only
      this.makeAllColumnsReadOnly(rowIndex);
      
      this.hot.render();
    },


    handleWorkflowSuccess(response, rowIndex) {
      if (this.table.includes("greenhouse")) {
        this.handleGreenhouseSuccess(response, rowIndex);
      } else {
        this.handleRegularWorkflowSuccess(response, rowIndex);
      }
      
      this.hot.render();
    },


    handleGreenhouseSuccess(response, rowIndex) {
      this.setCell(rowIndex, "id", response.data.insert_result.id);
      
      if (response.message.templates) {
        this.setCell(rowIndex, "page_results", response.message.results);
        this.setCell(rowIndex, "page_templates", response.message.templates);
      } else {
        this.setCell(rowIndex, "page_results", response.message);
      }
      
      if (!response.message.templates && response.message.includes("ERROR:")) {
        this.setCellMeta(rowIndex, "page_results", "valid", false);
      }
      
      this.setCellMeta(rowIndex, "id", "className", "success");
      this.makeRowReadOnly(rowIndex);
    },


    handleRegularWorkflowSuccess(response, rowIndex) {
      //console.log(response)
      const candidateId = Number(response.data.candidate_id);
      const csrId = Number(response.data.csr_id);
      
      this.setCell(rowIndex, "candidate_id", candidateId);
      this.setCell(rowIndex, "candidate_stage_results_id", csrId);
      this.setCellMeta(rowIndex, "candidate_id", "className", "success");
      this.setCellMeta(rowIndex, "candidate_stage_results_id", "className", "success");
    },


    setCell(rowIndex, propName, value) {
      this.hot.setDataAtCell(rowIndex, this.hot.propToCol(propName), value);
    },


    setCellMeta(rowIndex, propName, property, value) {
      this.hot.setCellMeta(rowIndex, this.hot.propToCol(propName), property, value);
    },


    makeAllColumnsReadOnly(rowIndex) {
      for (let j = 0; j < this.hot.countCols(); j++) {
        this.hot.setCellMeta(rowIndex, j, "readOnly", true);
      }
    },


    makeRowReadOnly(rowIndex) {
      for (let j = 0; j < this.hot.countCols() - 1; j++) {
        this.hot.setCellMeta(rowIndex, j, "readOnly", true);
      }
    },


    finalizeSubmission() {
      this.workingOnSubmittedData = false;
      this.loading = false;
    },


    checkForDupes() {
      let colIndex =
        this.hot.propToCol("candidate.id");
      let arry =
        this.hot.getSourceDataAtCol(colIndex);
      
      let toFindDuplicates = (arry) =>
        arry.filter((item, index) => item > 0 && arry.indexOf(item) !== index);
      let duplicateCandidates = toFindDuplicates(arry);
      return duplicateCandidates;
    },


    getColumnSorting(table_name) {
      if (table_name.includes("greenhouse")) {
        return true;
      } else {
        return false;
      }
    },


    updateErrorComments(badArray) {
      let errorColumn;
     
      for (const item of badArray) {
        if (item.error[0] && typeof item.error[0] !== "string") {
          for (const field of Object.keys(item.error[0])) {
            errorColumn = this.hot.propToCol(field);
                       
            if (isNaN(errorColumn)) {
              // this indicates that we are working with a json field (a field to a related table)
              errorColumn = this.hot.propToCol(field + '.id')
             
            }
            if (field !== "0" && field !== "id") {
                this.$refs.hot.updateErrorValue(
                this.hot.toVisualRow(item.row),
                //this.hot.toVisualColumn(errorColumn)
                errorColumn,
                item.error[0][field]
                             
              );
            } else if (item.error.indexOf("column") > -1) {
              let field = /"(.*?)"/g.exec(item.error);
              errorColumn = this.hot.propToCol(
                field[1]
              );
               
              this.$refs.hot.updateErrorValue(
                this.hot.toVisualRow(item.row),
                //this.hot.toVisualColumn(errorColumn),
                errorColumn,
                item.error
              );
            } else {
              errorColumn =
                this.hot.propToCol("id");
               
              this.$refs.hot.updateErrorValue(
                this.hot.toVisualRow(item.row),
                //this.hot.toVisualColumn(errorColumn),
                errorColumn,
                item.error
              );
            }
          }
        } else {
          let errorMessage = item.error.errors ? item.error.errors : item.error;
         
             this.$refs.hot.updateErrorValue(
               this.hot.toVisualRow(item.row),
               0,
               errorMessage
             );
            
            this.hot.render();
       }
         
      }
    },

   
    async createDataSchema(){
      let result = [];

      // Loop over each item in the input data
      await this.columnMetaData.forEach(item => {
        // Get the key name (property name) from the item
        let key = item['data']
        
        // Set the value for this key to null
        // if its a relatedtable we need to set the value of both the id and the field to render
        if (key.endsWith('.id')) {
          //let colToRender = item['colToRender']
          key = key.slice(0, -3);
          //result[key] = { id: null, [colToRender]: null};
          result[key] = { id: null }
          //result[key] = null
        } else if (key.endsWith('.name') ) { 
          // this it the photo in the people table
          //let colToRender='file.name'
          key = key.slice(0, -5)
          result[key] = { name: null }
        } else if (item['dataType'] === 'boolean' && item['default_value'] !== null) { 
             result[key] =  item['default_value'] ;  //change string to boolean^M
        } else {
            result[key] = null;
        }
          
      });
      
      return result;

    },

  
    async addRows() {
      let i=1;
      //because of a bug in handsontable, the first row must have very field (including related table fields) initialized. https://forum.handsontable.com/t/gh-9513-comments-plugin-problem/6149
      this.hotdata.push({...this.dataschema}) 
        
      while (i < 500){ 
          this.hotdata.push({})
          i++;
      }
      //this.$refs.hot.$refs.hot.hotInstance.loadData(this.hotdata);
      this.hot.loadData(this.hotdata)

    }
  
  },

  data() {
    return {
      hot: null,
      hotdata: [],
      columnMetaData: [],
      pageDisclaimer: null,
      table: this.$route.params.table,
      loading: false,
      showSearch: false,
      workingOnsubmittedData: false,
      query: null,
      picked: null,
      visible: false,
      submitAddsClicked: false,
      workflow: '',
      pageError: null,
      permissions: this.getTablePermissions(this.$route.params.table),
      visibility: "display:inline",
      columnSorting: this.getColumnSorting(this.$route.params.table),
      dataschema:[],
      hiddenColumns: [],
      workflowOptions: [],
      hideRaceCreationColumnsSets: {
      All: [],                // show everything
      GeneralOnly: ['stage_url_D', 'stage_url_R', 'stage_url_NP', 'partisan_primary','is_ranked_choice_dem_primary',
        'is_ranked_choice_rep_primary', 'is_ranked_choice_non_partisan_primary','primary_date.id'
      ], 
      PrimaryOnly: ['description', 'date_term_ends', 'swearing_in_date', 'general_date.id',
        'is_ranked_choice_general','date_new_term_ends'      ]  
    }
    };
  },


  beforeMount: async function () {
    this.canAdd = this.permissions.includes("INSERT");
    this.canUpdate = this.permissions.includes("UPDATE");
  },


  mounted: async function () {
   
    // Block add page for certain tables
    const tablesWithoutAddPage = ['district_boundaries', 'files', 'ultralocal.ul_file_uploads', 'officeholder_photos_staging', 'tiktok_people_photos', 'fetch_services.response_election_dates'];
    if (tablesWithoutAddPage.includes(this.table)) {
      alert(`The Add page is not available for the ${this.table} table.`);
      this.$router.push({ path: `/edit/${this.table}` });
      return;
    }
   
    this.hot = this.$refs.hot.$refs.hot.hotInstance
    this.hotdata.splice(0, this.hotdata.length); // Clear the array
    this.columnMetaData.splice(0, this.columnMetaData.length); // Clear the array
    this.dataschema.splice(0, this.dataschema.length)
    
    await this.generateColumnMetaData("Add", this.table);

    this.workflowOptions = await this.getHotWorkflows(this.table, 'add');

    let i = 0;
    this.dataschema = await this.createDataSchema();
    // due to a bug in handsontable, every field in the first row in the add table needs to be initialized.
    // this is done in the addrows method using the dataschema created above.
    //  we don't want this initialized row to be used to create records
    // so below, we make it readonly and we hide it. 
    
    this.hot.updateSettings({
      dataSchema: this.dataschema,
      columns: this.columnMetaData,
       cells: (row, col) => {
        const cellProperties = {};
        // Make the first data row (index 1) read-only
        if (row === 0) {
          cellProperties.readOnly = true;
        }
        return cellProperties;
      },
      hiddenRows: {
        rows: [0] // Hide the first data row (row index 1) -  we don't want to use the first row since it is pre-initialized
      },
      comments: true
    });
    await this.addRows()
     
    this.hideColumns(); // doesn't work if you try to hide the columns in the above updateSettings or before adding rows
    this.pageDisclaimer = await this.getPageDisclaimer(this.table);
    this.hot.loadData(this.hotdata);
          
  }
  

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.btn {
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.submit-btn {
  width: 150px;
}

.checkbox {
  margin-top: 0px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}

.modal-container .btn {
  margin: 0 auto;
}

.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}

.modal-body {
  margin: 20px 0;
  white-space: pre-line;
}

.modal-default-button {
  margin: 0 auto;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.search-options label {
  font-size: 12px;
}

.search-options .form-control {
  height: 30px;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
